import React from 'react';
import {Form, Input, Button, Select, Layout} from 'antd';
import ApprovalBar from './sidebar/ApprovalBar'
import HeaderNav from "../header/header";
const { Content, Sider } = Layout;

class Approval extends React.Component {
    render() {
        return <div>
            <HeaderNav parmas={'/approval'}/>
            <Layout className="site-layout-background" style={{ padding: '24px 0' }}>
                <Content style={{ padding: '0 24px', minHeight: 280 }}>
                    <h1>Lenovo Internal</h1>
                    <Form
                        name="internal"
                        labelCol={{ span: 4 , offset:5}}
                        wrapperCol={{ span: 10}}
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Form.Item
                            label="Brand"
                            name="brand"
                            rules={[{ required: true, message: 'Please input your brand!' }]}
                        >
                            <Select />
                        </Form.Item>

                        <Form.Item
                            label="Customer's Sold To"
                            name="customerSoldTo"
                            rules={[{ required: true, message: 'Please input your Customer\'s Sold To!' }]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            label="Your Email Address"
                            name="yourEmailAddress"
                            rules={[{ required: true,message: 'Please input your Email Address!' }]}
                        >
                            <Input defaultValue={'@lenovo.com'}/>
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 9, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Content>
                <Sider className="site-layout-background" width={300}>
                    <ApprovalBar />
                </Sider>
            </Layout>
        </div>
    }
}

export default Approval